export const hasOwn = (value, key) => {
  return Object.prototype.hasOwnProperty.call(value || {}, key);
};
